<template>
  <div>
    <hr class="mt-0" />
    <div class="row" v-if="isLoading">
       <div class="row">
        <div class="col-6">
          <p class="fw-semibold font-size-2">
            Booking details

            <span
              type="span"
              class="badge bg-success text-white font-size-12"
              v-if="booking_details.booking_source == 2"
              >Mobile</span
            >
            <span
              type="span"
              class="badge bg-danger text-white font-size-12"
              v-if="booking_details.booking_source == 1"
              >Admin
            </span>
          </p>
        </div>
        <div class="col-6 text-end">
          <button
            style="
              color: #449834 !important;
              background: none;
              border: none;
              padding: 0;
              text-decoration: underline;
              text-decoration-thickness: 3px;
            "
            @click="goBack"
          >
            Close
          </button>
        </div>
      </div>
      <div class="col-md-6 border-end">

        <ul class="basic-list font-size-1 fw-semibold basic-pad pe-5">
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Booking id</span>
            <span class="">
              {{ booking_details.bookingId }}
            </span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Transaction id</span>
            <span class="">
              {{ booking_details.transaction_id }}
            </span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Booking date</span>
            <span class="">
              {{ dateTime(booking_details.created_ts) }}</span
            >
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Retreat</span>
            <span class="">{{
              booking_details._farm_retreat_id.display_name
            }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Cottage</span>
            <span class="">{{
              booking_details._farm_retreat_cottage_id.cottage_name
            }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">No of cottages</span>
            <span class="">{{ booking_details.cottage_count }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Check in</span>
            <span class="">{{
              dateTime(booking_details.check_in)
            }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Check out</span>
            <span class="">{{
              dateTime(booking_details.check_out)
            }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Days & Nights</span>
            <span class=""
              >{{ booking_details.day_counts }}D
              {{ booking_details.night_counts }}N</span
            >
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Credits used</span>
            <span class="">{{ booking_details.credit_count }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Adults</span>
            <span class="">{{ booking_details.adult_counts }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Children</span>
            <span class="">{{ booking_details.child_counts }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Guests</span>
            <span class="">{{ booking_details.guest_counts }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Pets</span>
            <span class="">{{ booking_details.pets_counts }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Taxable Amount</span>
            <span class="">Rs {{ booking_details.tax_details?.taxableAmount }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Tax Amount</span>
            <span class="">Rs {{ booking_details.tax_details?.taxAmount }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Amount paid</span>

            <span class="">Rs {{ booking_details.tax_details?.totalPayableAmount ?? booking_details.amount_paid ?? 0 }}</span>
          </li>

          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Remarks</span>
            <span class="">{{ booking_details.remark }}</span>
          </li>

          <li class="mt-3">
            <p class="fw-semibold font-size-1 mb-2">Invoices</p>
            <table v-if="invoices.length" class="table table-sm table-bordered font-size-1">
              <thead>
                <tr>
                  <th>Invoice #</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="inv in invoices" :key="inv._id">
                  <td>{{ inv.invoice_number }}</td>
                  <td>{{ formatInvoiceType(inv.invoice_type) }}</td>
                  <td>{{ dateFormat(inv.issued_at) }}</td>
                  <td>₹{{ inv.summary?.grand_total }}</td>
                  <td>
                    <a
                      href="#"
                      class="btn btn-sm btn-outline-success"
                      @click.prevent="downloadInvoice(inv)"
                    >PDF</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-else class="text-muted font-size-1 mb-0">No invoice available for this booking.</p>
          </li>

          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Status</span>

            <span
              type="button"
              class="badge bg-primary text-white font-size-12"
              v-if="booking_details.status == 1"
              >Confirmed</span
            >
            <span
              type="span"
              class="badge bg-warning text-white font-size-12"
              v-if="booking_details.status == 2"
              >In Progress</span
            >
            <!-- <span type="span" class="badge bg-refunded text-white font-size-12"
                    v-if="booking_details.status == 3">Refunded</span> -->
            <span
              type="span"
              class="badge bg-danger text-white font-size-12"
              v-if="booking_details.status == 3"
              >Cancelled</span
            >
            <span
              type="span"
              class="badge bg-danger text-white font-size-12"
              v-if="booking_details.status == 4"
              >Payment Failed</span
            >
          </li>
          <template v-if="booking_details.status == 3">
            <li class="d-flex justify-content-between">
              <span class="text-gray-300">Refunded Amount</span>
              Rs. {{ booking_details.refunded_amount }}
            </li>
            <li class="d-flex justify-content-between">
              <span class="text-gray-300">Refunded Id</span>
              {{ booking_details.refund_id }}
            </li>
            <li class="d-flex justify-content-between">
              <span class="text-gray-300"
                >Reason for cancellation</span
              >
              {{ booking_details.refund_remarks }}
            </li>
            <li class="d-flex justify-content-between">
              <span class="text-gray-300"
                >Cancelled Date and Time</span
              >
              {{ dateAndTime(booking_details.refund_ts) }}
            </li>
            <li class="d-flex justify-content-between">
              <span class="text-gray-300">Refund Settled Date</span>
              {{
                booking_details.refund_settled_date
                  ? dateAndTime(booking_details.refund_settled_date)
                  : null
              }}
            </li>
          </template>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Payment / Refund Status</span>

            <span
              type="button"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 0"
              >INITIATED</span
            >
            <span
              type="button"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 1"
              >PAID</span
            >

            <span
              type="span"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 2"
              >FAILED</span
            >
            <span
              type="span"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 3"
              >REFUND QUEUED</span
            >
            <span
              type="span"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 4"
              >REFUND APPROVED</span
            >
            <span
              type="span"
              class="badge bg-info text-white font-size-12"
              v-if="booking_details.payment_status == 5"
              >REFUNDED</span
            >
          </li>
        </ul>
      </div>
      <div class="col-md-6 px-5">
        <p class="fw-semibold font-size-2">Customer details</p>
        <ul class="basic-list font-size-1 fw-semibold basic-pad">
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Name</span>
            <span class="" v-if="booking_details.user_id">{{
              booking_details.user_id.name
            }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Mobile number</span>
            {{ booking_details.mobile }}
          </li>
          <li class="d-flex justify-content-between">
            <span class="text-gray-300">Email address</span>
            {{ booking_details.email }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row mt-3 mb-5">
      <div class="col-md-12 text-end">
        <span v-if="booking_details.status == 2">
          <button
            type="button"
            class="btn bg-gray fw-light px-4 border me-4"
            @click="goBack"
          >
            Close
          </button>

          <button
            type="button"
            class="btn bg-refunded fw-light text-white px-4"
            @click="cancelBooking(3)"
            disabled="true"
          >
            Refund Completed
          </button>
        </span>

        <span v-if="booking_details.status == 3">
          <button
            type="button"
            class="btn bg-gray fw-light px-4 border me-4"
            @click="goBack"
          >
            Close
          </button>
        </span>

        <span v-if="booking_details.status == 1">
          <a
            type="button"
            class="btn bg-gray fw-light px-4 border me-4"
            @click="goBack"
            >Close</a
          >

          <button
            v-if="booking_details.booking_source == 1"
            type="button"
            class="btn bg-gray fw-light px-4 border me-4"
            @click="openRescheduleModal"
          >
            Reschedule
          </button>
          <button
            v-if="booking_details.booking_source == 1"
            type="button"
            class="btn bg-refunded fw-light text-white px-4"
            @click="cancelBooking(2)"
          >
            Cancel booking
          </button>
        </span>
      </div>
    </div>

    <div
      class="modal fade show"
      :class="{ showPopup: 'show' }"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
      :style="{ display: displayType }"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-3" style="width: 460px">
          <form
            action=""
            @submit.prevent="cancellationFormSubmitted(3)"
          >
            <div class="modal-body">
              <h5 class="text-center mb-4">Cancel booking?</h5>
              <div class="textarea">
                <span class="fw-semibold"
                  >Reason for cancellation</span
                >
                <textarea
                  name=""
                  id=""
                  cols="45"
                  rows="10"
                  placeholder="Max 100 characters"
                  class="mt-2 p-2"
                  style="height: 160px"
                  v-model="form.reason_for_cancellation"
                  maxlength="100"
                ></textarea>
              </div>
              <div class="radio-buttons my-3">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="no_refund"
                    v-model="form.cancellation_type"
                    @change="typeModified"
                    value="No Refund"
                  />
                  <label class="form-check-label" for="no_refund"
                    >No Refund</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="refunded_amount"
                    v-model="form.cancellation_type"
                    @change="typeModified"
                    value="Refunded amount"
                  />
                  <label
                    class="form-check-label"
                    for="refunded_amount"
                    >Refunded amount</label
                  >
                </div>
              </div>
              <div
                v-if="form.cancellation_type == 'Refunded amount'"
                class="mb-2"
              >
                <label for="rf_amount_field" class="fw-semibold"
                  >Refunded amount</label
                >
                <input
                  type="number"
                  name="rf_amount_field"
                  id="rf_amount_field"
                  class="form-control mt-2"
                  maxlength="10"
                  v-model="form.refunded_amount"
                  placeholder="Amount in rupees"
                />
              </div>
              <div>
                <label for="rf_amount_field" class="fw-semibold"
                  >Refunded Credit Point</label
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="form.credit_point_refund"
                  readonly
                />
              </div>
            </div>

            <div class="modal-footer justify-content-center border-0">
              <button
                type="button"
                class="btn bg-transparent border"
                @click="togglePopup()"
              >
                Close
              </button>
              <button type="submit" class="btn bg-primary text-white">
                Confirm
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showPopup"></div>

    <!-- Reschedule modal -->
    <div
      class="modal fade show"
      :class="{ showPopup: 'show' }"
      id="rescheduleModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="rescheduleModalLabel"
      aria-hidden="true"
      :style="{ display: rescheduleModalDisplay }"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-3" style="width: 460px">
          <form @submit.prevent="submitReschedulePreview">
            <div class="modal-body">
              <h5 class="text-center mb-4">Reschedule booking</h5>
              <p class="text-muted small mb-3">Enter new check-in and check-out dates.</p>
              <div class="mb-3">
                <label for="reschedule_check_in" class="fw-semibold">New check-in</label>
                <input
                  id="reschedule_check_in"
                  type="date"
                  class="form-control mt-2"
                  v-model="rescheduleForm.new_check_in"
                  :min="minRescheduleDate"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="reschedule_check_out" class="fw-semibold">New check-out</label>
                <input
                  id="reschedule_check_out"
                  type="date"
                  class="form-control mt-2"
                  v-model="rescheduleForm.new_check_out"
                  :min="rescheduleForm.new_check_in || minRescheduleDate"
                  required
                />
              </div>
              <p
                v-if="reschedulePreviewMessage"
                class="small mb-2"
                :class="reschedulePreviewError ? 'text-danger' : 'text-success'"
              >
                {{ reschedulePreviewMessage }}
              </p>

              <ul
                v-if="!reschedulePreviewError && reschedulePriceDifference"
                class="basic-list font-size-1 fw-semibold basic-pad mb-3 border rounded p-3"
              >
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">Old amount</span>
                  <span>Rs {{ reschedulePriceDifference.oldAmount }}</span>
                </li>
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">Old taxable amount</span>
                  <span>Rs {{ reschedulePriceDifference.oldTaxableAmount }}</span>
                </li>
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">Old tax amount (5%)</span>
                  <span>Rs {{ reschedulePriceDifference.oldTaxAmount }}</span>
                </li>
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">New amount</span>
                  <span>Rs {{ reschedulePriceDifference.newAmount }}</span>
                </li>
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">New taxable amount</span>
                  <span>Rs {{ reschedulePriceDifference.newTaxableAmount }}</span>
                </li>
                <li class="d-flex justify-content-between mb-2">
                  <span class="text-gray-300">New tax amount (5%)</span>
                  <span>Rs {{ reschedulePriceDifference.newTaxAmount }}</span>
                </li>
                <li class="d-flex justify-content-between">
                  <span class="text-gray-300">Price difference</span>
                  <span
                    :class="
                      reschedulePriceDifference.difference > 0
                        ? 'text-danger'
                        : reschedulePriceDifference.difference < 0
                          ? 'text-success'
                          : ''
                    "
                  >
                    Rs {{ reschedulePriceDifference.difference }}
                  </span>
                </li>
                <li
                  v-if="reschedulePriceDifference.payableAmount != null"
                  class="d-flex justify-content-between mt-2 pt-2 border-top"
                >
                  <span class="text-gray-300">Payable amount</span>
                  <span>Rs {{ reschedulePriceDifference.payableAmount }}</span>
                </li>
              </ul>

              <div
                v-if="!reschedulePreviewError && reschedulePreviewMessage"
                class="mt-2"
              >
                <div class="mb-3">
                  <label for="reschedule_amount" class="fw-semibold"
                    >Amount</label
                  >
                  <input
                    id="reschedule_amount"
                    type="number"
                    class="form-control mt-2"
                    v-model.number="rescheduleForm.amount"
                    min="0"
                    placeholder="Amount in rupees"
                    required
                  />
                </div>
                <div class="mb-2">
                  <label
                    for="reschedule_payment_ref"
                    class="fw-semibold"
                  >
                    Payment reference (optional)
                  </label>
                  <input
                    id="reschedule_payment_ref"
                    type="text"
                    class="form-control mt-2"
                    v-model="rescheduleForm.payment_reference_id"
                    placeholder="Reference id"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-center border-0">
              <button
                type="button"
                class="btn bg-transparent border"
                @click="closeRescheduleModal"
              >
                Close
              </button>
              <button
                type="submit"
                class="btn bg-primary text-white"
                :disabled="rescheduleLoading"
              >
                {{ rescheduleLoading ? 'Loading...' : 'Preview reschedule' }}
              </button>
              <button
                type="button"
                class="btn bg-success text-white ms-2"
                :disabled="
                  rescheduleConfirmLoading ||
                  reschedulePreviewError ||
                  !reschedulePreviewMessage
                "
                @click="submitRescheduleBooking"
              >
                {{ rescheduleConfirmLoading ? 'Rescheduling...' : 'Reschedule booking' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showRescheduleModal"></div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      showPopup: false,
      data: [],
      booking_details: "",
      paymentDetails: [],
      isLoading: false,
      displayType: "none",
      form: {
        isCreditApplied: false,
        credit_point_refund: 0,
        reason_for_cancellation: "",
        cancellation_type: "No Refund",
        refunded_amount: 0,
        type: 0,
        check_in: "",
        check_out: "",
      },
      showRescheduleModal: false,
      rescheduleModalDisplay: "none",
      rescheduleForm: {
        new_check_in: "",
        new_check_out: "",
      },
      rescheduleLoading: false,
      rescheduleConfirmLoading: false,
      reschedulePreviewMessage: "",
      reschedulePreviewError: false,
      reschedulePriceDifference: null,
      invoices: [],
    };
  },
  computed: {
    minRescheduleDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    dateAndTime(value) {
      if (value) return moment(value).format("DD-MM-YYYY HH:MM:SS");
      else return "";
    },
    dateFormat(value) {
      if (value) return moment(value).format("DD-MM-YYYY");
      else return "";
    },
    typeModified() {
      if (this.form.cancellation_type == "No Refund") {
        this.form.refunded_amount = 0;
      }
    },
    getData() {
      let booking_id = this.$route.params.booking_id;
      this.$apiV1
        .get("/farm-stay/bookings/" + booking_id)
        .then((res) => {
          if (res.data.success) {
            this.isLoading = true;
            this.booking_details = res.data.data;
            this.paymentDetails = res.data.paymentDetails;
            this.invoices = res.data.invoices || [];
          }
        });
    },
    formatInvoiceType(type) {
      const map = {
        TAX_INVOICE: 'Tax Invoice',
        SUPPLEMENTARY_INVOICE: 'Supplementary',
        CREDIT_NOTE: 'Credit Note',
      };
      return map[type] || type;
    },
    downloadInvoice(inv) {
      this.$apiV1
        .get(`/farm-stay/invoices/${inv._id}/pdf`, { responseType: 'blob' })
        .then((res) => {
          const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          window.open(url, '_blank');
        })
        .catch((err) => {
          console.error(err);
          alert('Failed to download invoice PDF.');
        });
    },
    cancelBooking(type) {
      this.togglePopup();
    },
    cancellationFormSubmitted(type) {
      let booking_id = this.$route.params.booking_id;
      this.form.type = type;
      this.$apiV1
        .put(
          "/farm-stay/bookings/" + booking_id + "/status",
          this.form
        )
        .then((res) => {
          if (res.data.success) {
            alert(res.data.message);
            this.isLoading = true;
            location.reload();
          }
        });
    },
    getCancellationDetails() {
      let booking_id = this.$route.params.booking_id;
      this.$apiV1
        .get(
          "/farm-stay/bookings/" + booking_id + "/cancellation",
          this.form
        )
        .then((res) => {
          console.log(res);
          this.form.refunded_amount = res.data.refund_amount;
          this.form.credit_point_refund =
            res.data.credit_point_refund;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
      if (this.displayType == "block") {
        this.displayType = "none";
      } else {
        this.displayType = "block";
        this.getCancellationDetails();
      }
    },
    dateTime(value) {
      if (value) return moment(value).format("DD-MM-YYYY");
      else return "";
    },
    openRescheduleModal() {
      this.rescheduleForm.new_check_in = this.booking_details.check_in
        ? moment(this.booking_details.check_in).format("YYYY-MM-DD")
        : "";
      this.rescheduleForm.new_check_out = this.booking_details.check_out
        ? moment(this.booking_details.check_out).format("YYYY-MM-DD")
        : "";
      this.reschedulePreviewMessage = "";
      this.reschedulePreviewError = false;
      this.reschedulePriceDifference = null;
      this.rescheduleLoading = false;
      this.rescheduleConfirmLoading = false;
      this.rescheduleForm.amount = "";
      this.rescheduleForm.payment_reference_id = "";
      this.showRescheduleModal = true;
      this.rescheduleModalDisplay = "block";
    },
    closeRescheduleModal() {
      this.showRescheduleModal = false;
      this.rescheduleModalDisplay = "none";
      this.reschedulePreviewMessage = "";
      this.reschedulePreviewError = false;
      this.reschedulePriceDifference = null;
      this.rescheduleLoading = false;
      this.rescheduleConfirmLoading = false;
    },
    submitReschedulePreview() {
      const booking_id = this.$route.params.booking_id;
      this.rescheduleLoading = true;
      this.reschedulePreviewMessage = "";
      this.reschedulePreviewError = false;
      this.reschedulePriceDifference = null;
      this.$apiV1
        .post(
          "/farm-stay/bookings/" +
            booking_id +
            "/reschedule/preview",
          {
            new_check_in: this.rescheduleForm.new_check_in,
            new_check_out: this.rescheduleForm.new_check_out,
          }
        )
        .then((res) => {
          this.rescheduleLoading = false;
          if (res.data.success) {
            this.reschedulePreviewMessage = res.data.message || "Preview loaded successfully.";
            this.reschedulePreviewError = false;
            this.reschedulePriceDifference = res.data.data?.price_difference || null;
            if (this.reschedulePriceDifference?.payableAmount != null) {
              this.rescheduleForm.amount = this.reschedulePriceDifference.payableAmount;
            }
          } else {
            this.reschedulePreviewMessage = res.data.message || "Preview failed.";
            this.reschedulePreviewError = true;
            this.reschedulePriceDifference = null;
          }
        })
        .catch((err) => {
          this.rescheduleLoading = false;
          this.reschedulePreviewMessage =
            err.response?.data?.message || "Failed to get reschedule preview.";
          this.reschedulePreviewError = true;
          this.reschedulePriceDifference = null;
        });
    },
    submitRescheduleBooking() {
      const booking_id = this.$route.params.booking_id;

      if (!this.rescheduleForm.new_check_in || !this.rescheduleForm.new_check_out) {
        this.reschedulePreviewMessage = "Please select new check-in and check-out dates.";
        this.reschedulePreviewError = true;
        return;
      }

      this.rescheduleConfirmLoading = true;
      this.$apiV1
        .post("/farm-stay/retreats/booking/reschedule", {
          booking_id,
          new_check_in: this.rescheduleForm.new_check_in,
          new_check_out: this.rescheduleForm.new_check_out,
          amount: this.rescheduleForm.amount,
          payment_reference_id: this.rescheduleForm.payment_reference_id || null,
          skip_payment: true,
        })
        .then((res) => {
          this.rescheduleConfirmLoading = false;
          if (res.data.success) {
            alert(res.data.message || "Booking rescheduled successfully.");
            this.closeRescheduleModal();
            this.getData();
          } else {
            this.reschedulePreviewMessage =
              res.data.message || "Failed to reschedule booking.";
            this.reschedulePreviewError = true;
          }
        })
        .catch((err) => {
          this.rescheduleConfirmLoading = false;
          this.reschedulePreviewMessage =
            err.response?.data?.message || "Failed to reschedule booking.";
          this.reschedulePreviewError = true;
        });
    },
  },
};
</script>
